import { render } from "./OperationLogs.vue?vue&type=template&id=5e8d523e&scoped=true"
import script from "./OperationLogs.vue?vue&type=script&lang=js"
export * from "./OperationLogs.vue?vue&type=script&lang=js"

import "./OperationLogs.vue?vue&type=style&index=0&id=5e8d523e&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8d523e"]])

export default __exports__